import GlobalReduxStore from 'stores/globalReduxStore';
import {SignalREvent, SignalRHub} from '../constants/dataEnum';
import {invokeAPI} from '../stores/business/commonBusiness';

export const loadCellError = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_LOAD_CELL_ERROR));
  } catch (error) {
    console.error('error in loadCellError', error);
  }
  return response;
};

export const tryRecoverLoadcellError = async () => {
  let response;
  const {dispatch} = GlobalReduxStore.getStore();
  try {
    response = await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.TRY_RECOVER_LOAD_CELL_ERROR));
  } catch (error) {
    console.error('error in tryRecoverLoadcellError', error);
  }
  return response;
};
